import { createFileRoute, redirect } from '@tanstack/react-router';

/** Platform ▸ Coverage address: the page is its own sidebar item at /coverage, like Schedules. */
export const Route = createFileRoute('/_authenticated/_tenant/platform/coverage')({
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/coverage', search, replace: true });
  },
});
